import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {


  url = environment.serverAPI4 + "/api/vendor";

  url1 = environment.serverAPI + "/api/supplier/approve";

  constructor(private http: HttpClient) { }

  getAllVendor(Page: any, size: any, sort: any, supplierType: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&typeId=${supplierType}`);
  }

  getAllVendorDropDown(supplierType: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?typeId=${supplierType}`);
  }


  getVendorById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditVendor(vendor: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, vendor);
  }

  VendorSearch(query, Page: any, size: any, sort: any, supplierType: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&typeId=${supplierType}`);
  }

  getApproved(technician: any): Observable<Object> {
    return this.http.post(`${this.url1}`, technician);
  }

  downloadVendorTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downloadVendorReport(Page: number, size: number, sort, selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionUnits, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  checkVendorSubscription(): Observable<Object> {
    return this.http.get(`${this.url}/check/expired`);
  }

  checkVendorSubscriptionNew(): Observable<Object> {
    return this.http.get(`${this.url}/subscription/status`);
  }

}
